import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=c23ad5ee&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c23ad5ee')) {
      api.createRecord('c23ad5ee', component.options)
    } else {
      api.reload('c23ad5ee', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=c23ad5ee&", function () {
      api.rerender('c23ad5ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2SlpSuFoPezTE/JS/pricehelp.vue"
export default component.exports